import {createAction, props} from '@ngrx/store';
import {CreateDefaultEntitiesModel} from '@spout/any-shared/models';

export const createDefaultConfigsToFirestore = createAction(
  '[Onboarding/API] Create Default Configs',
  props<CreateDefaultEntitiesModel>()
);
